import { FC } from 'react'

import styled from 'styled-components'

import InfoIcon from 'src/Assets/Svg/common/info.svg?react'
import { useGetLanguagesForExistingPlaylistsQuery } from 'src/Redux/languagesApi'
import { GroupedOption, SelectedLanguage } from 'src/Types/tracks'

import {
  LanguageListLabel,
  LanguagesModalSpotifyGroupedItem,
} from './LanguagesModalSpotifyGroupedItem'
import { LanguagesModalSpotifySelectedLanguage } from './LanguagesModalSpotifySelectedLanguage'

const ListComponent = styled.ul<{ $hasMargin?: boolean }>`
  padding: 0;
  ${LanguageListLabel}:first-child {
    margin-top: ${({ $hasMargin }) => ($hasMargin ? '16px' : '0')};
  }
`

const NoResults = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
const NoResultsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`

interface Props {
  selectedLanguage: SelectedLanguage | null
  searchValue: string
  setValue: (value: string) => void
  targetLanguage?: number
  onClick: (item: SelectedLanguage) => void
  onChange: (id: number) => void
}

const getNewFilteredLanguages = (
  groupedOptions: GroupedOption[],
  searchValue: string,
): GroupedOption[] =>
  groupedOptions.map((item) => ({
    ...item,
    options: item.options.filter(({ label }) =>
      label?.toLowerCase().includes(searchValue.toLowerCase()),
    ),
  }))

export const LanguagesModalSpotifyWrapperList: FC<Props> = ({
  selectedLanguage,
  searchValue,
  setValue,
  targetLanguage,
  onClick,
  onChange,
}) => {
  const { data: groupedOptions } = useGetLanguagesForExistingPlaylistsQuery()

  const filteredOptions = getNewFilteredLanguages(
    groupedOptions || [],
    searchValue,
  )

  const showNoData =
    !filteredOptions[0]?.options?.length && !filteredOptions[1]?.options?.length

  if (selectedLanguage) {
    return (
      <>
        <LanguagesModalSpotifySelectedLanguage
          selectedLanguage={selectedLanguage}
          targetLanguage={targetLanguage}
          onClick={() => {
            onClick(selectedLanguage)
          }}
          onChange={onChange}
          searchValue={searchValue}
        />

        {searchValue && (
          <ListComponent $hasMargin={Boolean(selectedLanguage)}>
            {filteredOptions.map((item) => (
              <LanguagesModalSpotifyGroupedItem
                key={item.label}
                searchValue={searchValue}
                item={item}
                onClick={onClick}
                selectedLanguage={selectedLanguage}
              />
            ))}
          </ListComponent>
        )}
      </>
    )
  }

  if (showNoData) {
    return (
      <NoResultsContainer>
        <InfoIcon width={16} height={16} />
        <NoResults>No search results</NoResults>
      </NoResultsContainer>
    )
  }

  return (
    <ListComponent $hasMargin={Boolean(selectedLanguage)}>
      {filteredOptions.map((item) => (
        <LanguagesModalSpotifyGroupedItem
          key={item.label}
          searchValue={searchValue}
          item={item}
          onClick={(v) => {
            onClick(v)
            setValue('')
          }}
        />
      ))}
    </ListComponent>
  )
}
